import axios from "axios";
import React, { useState, useEffect } from "react";
import { Container } from "@material-ui/core";
import Markdown from "markdown-to-jsx";

const TextRandom = (props) => {
  const { id, updateAssign } = props;
  const [sections, setSections] = useState([]);
  const [text, setText] = useState("");

  console.log("TextRandom component mounted with id:", id);

  useEffect(() => {
    if (id) {
      console.log("Fetching textrandom data for id:", id);
      (async () => {
        try {
          const doc = await axios.get("/api/gui/textrandom/" + id);
          console.log("Received textrandom data:", doc.data);
          setSections(doc.data.sections || []);
        } catch (error) {
          console.error("Error fetching textrandom data:", error);
        }
      })();
    }
  }, [id]);

  useEffect(() => {
    if (sections.length > 0) {
      console.log("Sections available, selecting random text");
      // Randomly select a section with equal probability
      const index = Math.floor(Math.random() * sections.length);
      setText(sections[index]);

      const assign = {
        id,
        type: "textrandom",
        text: index + 1,
      };
      updateAssign(assign);
    }
  }, [sections]);

  return (
    <Container id="text">
      <br />
      {text ? (
        <Markdown>{text}</Markdown>
      ) : (
        <div>No text sections available</div>
      )}
      <br />
      <br />
    </Container>
  );
};

export default TextRandom;
